import { notification } from "antd";
import { get } from "lodash";
import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBackIos, MdCheckCircle, MdSend } from "react-icons/md";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM, DATE_FORMAT } from "utils/constants";

const FORMULA_LABELS = { solo: "Téléconsultation Solo", duo: "Téléconsultation Duo", famille: "Téléconsultation Famille" };

const Quote = ({ project, onNext, onBack }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const DETAIL = t("DETAIL", { returnObjects: true });
  const [sent, setSent] = useState(false);
  const [nextLoading, setNextLoading] = useState(false);

  const contactEmail = get(
    (get(project, "contact.telecoms", []) || []).find(({ system }) => system === CONTACT_POINT_SYSTEM.EMAIL),
    "value",
    "",
  );
  const totalPrice = get(project, "fields.totalPrice", 0);
  const selectedTeleconsultation = get(project, "fields.selectedTeleconsultation", "solo");

  const handleSend = () => {
    setSent(true);
    notification.success({ message: "Devis généré avec succès et envoyé par email au prospect" });
  };

  const handleContinue = () => {
    setNextLoading(true);
    onNext({
      payload: {
        fields: { ...project.fields, quoteSent: true },
      },
      onCompleted: () => setNextLoading(false),
      onError: () => setNextLoading(false),
    });
  };

  return (
    <>
      <Header key="header" title="Devis" />
      <div className="contact-form" key="form_area">
        <div className="contact-form__content">
          <Form
            title="Génération du Devis"
            description="Génération et envoi automatique du devis personnalisé"
          >
            {sent ? (
              <Alert showIcon type="success" icon={<MdCheckCircle size={16} />} message="Devis envoyé avec succès" description="Le devis a été envoyé par email au prospect" />
            ) : (
              <Alert showIcon type="info" icon={<MdSend size={16} />} message="Prêt à envoyer" description="Cliquez sur le bouton pour générer et envoyer le devis" />
            )}

            <div className="contact-stepper" key="DEVIS">
              <div className="contact-stepper__header">
                <div className="contact-stepper__header--counter">
                  <span>1</span>
                </div>
                <div className="contact-stepper__header--content">
                  <h1 className="contact-stepper__header--content--title">
                    <span>DEVIS N° DEV-{moment().format("YYYYMMDD")}</span>
                  </h1>
                  <p className="contact-stepper__header--content--description">
                    Valable jusqu'au {moment().add(30, "d").format(DATE_FORMAT)}
                  </p>
                </div>
              </div>
              <div className="contact-stepper__content">
                <div className="d-flex justify--between">
                  <span>Client:</span>
                  <span>{contactEmail}</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Produit:</span>
                  <span>{FORMULA_LABELS[selectedTeleconsultation]}</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Prix unitaire:</span>
                  <span>{totalPrice.toFixed(2)} €</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Quantité:</span>
                  <span>1</span>
                </div>
                <div className="d-flex justify--between">
                  <span>Sous-total:</span>
                  <span>{totalPrice.toFixed(2)} €</span>
                </div>
                <div className="d-flex justify--between">
                  <strong>Total mensuel:</strong>
                  <strong className="text--primary">{totalPrice.toFixed(2)} €</strong>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <div className="contact-form__action">
          <div className="d-flex justify--between" style={{ width: "100%" }}>
            <Button onClick={onBack} type="secondary--link" loading={nextLoading}>
              <MdArrowBackIos size={16} />
              Retour
            </Button>
            {sent ? (
              <Button type="primary" onClick={handleContinue} loading={nextLoading}>
                Continuer vers la souscription
                <MdSend size={16} />
              </Button>
            ) : (
              <Button type="primary" onClick={handleSend}>
                <MdSend size={16} />
                Prévisualiser et envoyer le devis
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Quote;
